<template>
  <v-card class="white--text" color="primary darken-2" flat>
      <v-card-title class="pa-0">
          <span id="title-text">Situação por período</span>
        </v-card-title>
      <v-card-subtitle class="pa-0 mt-2">
            <v-icon class="mr-2" size="18" color="secondary lighten-1">icon-infohidro-reservatorio</v-icon>
            <span id="basin-text">{{basin.text}}</span>
      </v-card-subtitle>
      <v-card-text class="pa-0 white--text">
        <v-row>
          <v-col cols="12">
            <search-period-date
              :basin="basin"
              @applyPeriod="applyDateSelected($event)"
            >
            </search-period-date>
          </v-col>

          <v-col cols="12">
            <volume-charts
              :periodDate="periodDate"
              :basin="basin"
              tabName="basins"
              :usefulVolume="usefulVolume"
              :usefulVolumePercentage="usefulVolumePercentage"
            >
            </volume-charts>
          </v-col>

          <v-col cols="12" md="6">
            <useful-volume-area
              :periodDate="periodDate"
              :basin="basin"
              tabName="basins"
              :usefulVolume="usefulVolume"
            >
            </useful-volume-area>
          </v-col>

          <v-col cols="12" md="6">
            <level-under-spillway
              :periodDate="periodDate"
              :basin="basin"
              :levelUnderSpillway="calculateQuote(levelUnderSpillway)"
            >
            </level-under-spillway>
          </v-col>
        </v-row>
      </v-card-text>
  </v-card>
</template>

<script>
import SearchPeriodDate from '../common/SearchPeriodDate.vue';
import VolumeCharts from '../common/VolumeCharts.vue';
import UsefulVolumeArea from '../common/UsefulVolumeArea.vue';
import LevelUnderSpillway from './LevelUnderSpillway.vue';
export default
{
  components: { SearchPeriodDate, VolumeCharts, UsefulVolumeArea, LevelUnderSpillway},
    name: 'BasinsSearchPeriodDate',
    props:['basin'],
    data:()=>({
      periodDate: undefined,
    }),
    watch:{
      periodDate(value){
        if(value){
            this.initializeData();
        }
      },
      basin(value){
        if(value){
          this.initializeData();
        }
      },
    },
    computed:{
      usefulVolume(){
        return this.$store.getters.usefulVolume;
      },
      usefulVolumePercentage(){
        let usefulVolumePercentage = this.$store.getters.usefulVolumePercentage;
        for (const key in usefulVolumePercentage) {
          usefulVolumePercentage[key].valor = usefulVolumePercentage[key].valor*100;
        }
        return usefulVolumePercentage;
      },
      levelUnderSpillway(){
        return this.$store.getters.levelUnderSpillway;
      }
    },
    methods:{
      async initializeData(){
        if(this.periodDate && this.basin){
          this.loading = true;
          this.showAnimation = true;
          const date_start = this.periodDate.period[0];
          const date_end = this.periodDate.period[1];
          const { type } = this.periodDate;
          const { codigo } = this.basin;
          const formatType = type === "Mensal" ? "monthly" : "daily";
          const station_ids = codigo;
          await Promise.all([
            this.$store.dispatch('loadUsefulVolume',{
              date_start,
              date_end,
              station_ids,
              sensor_ids: "294",
              operation_ids: "1",
              type: formatType,
              sort: "asc",
            }),
            this.$store.dispatch('loadUsefulVolumePercentage',{
              date_start,
              date_end,
              station_ids,
              sensor_ids: "188",
              operation_ids: "1",
              type: formatType,
              sort: "asc",
            }),
            this.$store.dispatch('loadLevelUnderSpillway',{
              date_start,
              date_end,
              station_ids,
              sensor_ids: "18",
              operation_ids: "1",
              type: formatType,
              sort: "asc",
            }),
          ]);

          this.loading = false;
        }
      },

      applyDateSelected(period){
        this.periodDate = period;
      },

      calculateQuote(levelData){
        const { COTA_MAXIMA_OPERACIONAL } = this.basin;
        if(COTA_MAXIMA_OPERACIONAL && levelData){
          return levelData.map((data) => ({
            ...data,
            valor: data.valor - COTA_MAXIMA_OPERACIONAL
          }));
        }
        return levelData;
      }
    },

}
</script>

<style scoped>
    #title-text{
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 23px;
        color: #fff;
    }

    #basin-text{
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 20px;
        color: #fff;
    }
</style>